import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaUser, FaCog, FaSignOutAlt, FaExchangeAlt, FaQuestionCircle } from 'react-icons/fa';
import { resolveUploadUrl } from '../config';

function AdminProfileDropdown({ user, onLogout }) {
  const [isOpen, setIsOpen] = useState(false);
  const [avatarError, setAvatarError] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setAvatarError(false);
  }, [user?.avatar_url]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-10 h-10 bg-green rounded-full flex items-center justify-center text-navy font-bold hover:bg-green/80 transition-colors cursor-pointer overflow-hidden"
      >
        {user?.avatar_url && !avatarError ? (
          <img src={resolveUploadUrl(user.avatar_url)} alt={user?.full_name || 'A'} onError={() => setAvatarError(true)} className="w-full h-full object-cover" />
        ) : (
          user?.full_name?.charAt(0) || 'A'
        )}
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-64 bg-white rounded-xl shadow-xl border border-gray-200 z-50">
          <div className="p-4 border-b border-gray-200">
            <p className="font-semibold text-navy">{user?.full_name || 'Admin'}</p>
            <p className="text-xs text-gray-500">{user?.email || 'admin@onepurpose.com'}</p>
            <span className="text-xs bg-green-100 text-green-600 px-2 py-0.5 rounded-full mt-1 inline-block">Admin</span>
          </div>

          <div className="p-2">
            <Link
              to="/profile"
              className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors text-gray-700"
              onClick={() => setIsOpen(false)}
            >
              <FaUser size={16} className="text-gray-400" />
              <span>My Profile</span>
            </Link>
            <Link
              to="/settings"
              className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors text-gray-700"
              onClick={() => setIsOpen(false)}
            >
              <FaCog size={16} className="text-gray-400" />
              <span>Settings</span>
            </Link>
            <Link
              to="/audit-log"
              className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors text-gray-700"
              onClick={() => setIsOpen(false)}
            >
              <FaExchangeAlt size={16} className="text-gray-400" />
              <span>Audit Log</span>
            </Link>
            <Link
              to="/help"
              className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors text-gray-700"
              onClick={() => setIsOpen(false)}
            >
              <FaQuestionCircle size={16} className="text-gray-400" />
              <span>Help</span>
            </Link>
          </div>

          <div className="border-t border-gray-200 p-2">
            <button
              onClick={onLogout}
              className="flex items-center gap-3 px-3 py-2 w-full rounded-lg hover:bg-red-50 transition-colors text-red-600"
            >
              <FaSignOutAlt size={16} />
              <span>Logout</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminProfileDropdown;
